import { useEffect, useState } from "react";

// Kundelenken #/tilbud/<token>. Vises uten innlogging og utenfor resten av
// Mimin (se CRM.tsx), så den henter tilbudet selv via quote_public.
export const PUBLIC_QUOTE_PREFIX = "#/tilbud/";

export const publicQuoteToken = (hash = window.location.hash) => {
  if (!hash.startsWith(PUBLIC_QUOTE_PREFIX)) return null;
  const token = hash.slice(PUBLIC_QUOTE_PREFIX.length).split(/[/?]/)[0];
  return token || null;
};

export const usePublicQuoteToken = () => {
  const [token, setToken] = useState(() => publicQuoteToken());
  useEffect(() => {
    const update = () => setToken(publicQuoteToken());
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);
  return token;
};
